import { Button } from "@mui/material";
import { useWindowSize } from "@react-hook/window-size/throttled";
import React, { useEffect, useState } from "react";
import { BsClockFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import StrokePattern from "../../../components/stroke-pattern/stroke-pattern";
import "./job-management.scss";

const JobManagement = () => {
  const [playerSize, setPlayerSize] = useState("612px");
  const [width, height] = useWindowSize();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="jobManagement full-width-element">
      <div className="problemBox">
      <img src="/images/Dotted-random-pattern.svg" className="dotted-random-pattern" />

        <h1 className="bigHeading">Job management</h1>
        <p className="subtitle2">
          If your business experiences any of these challenges around job or project management, the Kzen8 platform can help:<br></br>
          <br></br>
        </p>

        <div className="challengeContainer">
          <div className={`challengeBox primary body ${width > 475 ? "floatUpAnimation" : ""} animated delay-1-half`} style={{ marginLeft: "20%" }}>
            You don't have a single source of truth that tracks a job from start to finish, ensuring along the way that everything has been done as it should be.<br></br>
          </div>

          <div className={`challengeBox primaryG body ${width > 475 ? "floatUpAnimation" : ""} animated  delay-1-quarter`} style={{ marginRight: "30%" }}>
            You have tried using spreadsheets or other low cost software tools but there are now too many jobs and staying on top of them is becoming difficult.<br></br>
          </div>

          <div className={`challengeBox secondary body ${width > 475 ? "floatUpAnimation" : ""} animated delay-1`} style={{ marginRight: "35%" }}>
            You have a mobile workforce and giving them the information they need to complete a specific job is time consuming.<br></br>
          </div>

          <div className={`challengeBox tertiary body ${width > 475 ? "floatUpAnimation" : ""} animated`}>
            You have stringent regulations around how you work which causes concerns around non-compliance.<br></br>
            <br></br>
          </div>
          <div className="background">
            <img src="/images/Stressed.webp" style={{ height: playerSize }} />

            {/* <lottie-player src="/lottie-files/challenge.json" background="transparent" speed="1" style={{ width: playerSize, height: playerSize }} autoplay loop></lottie-player> */}
          </div>
        </div>
      </div>

      <div className="solutionBox cardShadow">
        <section className="left">
          <StrokePattern styles={{ position: "absolute", width: "200px", left: "-100px" }} />
          <h1 className="header">How we can help</h1>

          <p className="subtitle2 secondary-text-color">
            All solutions developed using the Kzen8 platform are completely bespoke to each business, but here is a short demo showing some features that a Kzen8 solution for job or project management could include:
          </p>

          <Link to="/contact-us">
            <Button variant="contained" className="btn btn-secondary subtitle2 callToAction" endIcon={<BsClockFill />}>Schedule a demo</Button>
          </Link>
        </section>

        <section className="right">
          <iframe
            width={Math.max(width / 1.75, 320)}
            height={Math.max(width / 3.15, 200)}
            src="https://www.youtube.com/embed/LnFhcvwvNIY"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}
          ></iframe>
          <img src="/images/Dotted pattern.svg" className="dotted-pattern" />
        </section>
      </div>
    </div>
  );
};

export default JobManagement;
